import { Injectable, inject } from '@angular/core';
import {DatabaseService} from '../shared/database.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {LibraryDirectory, LibraryType} from './library.model';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
  private databaseService = inject(DatabaseService);


  private libraryDirectoriesBS$ = new BehaviorSubject<LibraryDirectory[]>([]);
  private personalDirectoriesBS$ = new BehaviorSubject<LibraryDirectory[]>([]);
  libraryDirectories$ = this.libraryDirectoriesBS$.asObservable();
  personalDirectories$ = this.personalDirectoriesBS$.asObservable();
  private documentsChangedSubject = new Subject<LibraryType>();
  documentsChanged$ = this.documentsChangedSubject.asObservable();

  notifyDocumentsChanged(type: LibraryType): void {
    this.documentsChangedSubject.next(type);
  }

  public readDirectories(type: LibraryType) {
    this.databaseService.readDirectories(type)
      .subscribe((dirs) => {
        const sortedDirs = dirs.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        if(type === LibraryType.PUBLIC) {
          this.libraryDirectoriesBS$.next(sortedDirs);
        } else {
          this.personalDirectoriesBS$.next(sortedDirs);
        }

        }
      );
  }
}
